export function useBudget(status: string | number): boolean {
  return [0, 6].includes(Number(status));
}
